import { clearToken, getToken } from '@/auth/session';

export class ApiError extends Error {
    constructor(
        public status: number,
        message: string,
        public payload?: unknown
    ) {
        super(message);
    }
}

type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

async function request<T>(method: Method, path: string, body?: unknown): Promise<T> {
    const headers: Record<string, string> = {};
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;

    let payload: BodyInit | undefined;
    if (body instanceof FormData) {
        payload = body;
    } else if (body !== undefined) {
        headers['Content-Type'] = 'application/json';
        payload = JSON.stringify(body);
    }

    let res: Response;
    try {
        res = await fetch(path, { method, headers, body: payload });
    } catch {
        throw new ApiError(0, 'Нет связи с сервером');
    }

    if (res.status === 401) {
        clearToken();
        throw new ApiError(401, 'Сессия истекла, войдите снова');
    }

    let data: any = null;
    try {
        data = await res.json();
    } catch {
        /* пустое или не-JSON тело */
    }

    // Часть ручек отвечает 200 с { ok: false, error } — считаем это ошибкой.
    if (!res.ok || data?.ok === false) {
        throw new ApiError(res.status, data?.error || data?.message || `Ошибка ${res.status}`, data);
    }
    return data as T;
}

export const api = {
    get: <T>(path: string) => request<T>('GET', path),
    post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
    put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
    patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
    delete: <T>(path: string) => request<T>('DELETE', path),
};
